const cobhProcessor=(element)=>
{
let assembledElement=""

if (element["Change_in_frequency:"] !== "")
    {
     let frequencyText = ""
    switch (element["Change_in_frequency:"])
            {
            case "No change":
                frequencyText = " no change in bowel frequency"
                break

            case "Increased Frequency":
                frequencyText = " an increase in bowel frequency"
                break

            case "Decreased Frequency":
                frequencyText = " a decrease in bowel frequency"
                break

            case "Alternating Inc and Dec":
                frequencyText = " an alternating increase and decrease in bowel frequency"
                break

            default:
            }
    assembledElement += frequencyText
        }
     if (element["Change_in_frequency:"] === "" )
        {
        assembledElement += " a change in bowel habit"
        }

        
    if (element["Current_frequency:"] !== "")
        {
        assembledElement += (element["Change_in_frequency:"] === "No change" ? " with" : " to ")
        assembledElement += element["Current_frequency:"] 
        }

  

    if (element["Change_in_frequency:"] !== "")
    {
     let  consistencyText = ""
    switch (element["Change_in_consistency:"])
            {
            case "No change":
                consistencyText = " with no change in stool consistency"
                break

            case "Harder":
                consistencyText = " with harder stools"
                break

            case "Softer":
                consistencyText = " with softer stools"
                break
            
            case "Liquid":
                consistencyText = " with liguid stools"
                break

            case "Alternating hard and soft":
                consistencyText = " an alternating hard and soft stools"
                break

            default:
            }
    assembledElement +=  consistencyText
    }

if (element["Occurrance"] !== "")
{
assembledElement += `  ${element["Occurrance"].toLowerCase()}`
}


if (element["Present_for_several:"] !== "")
    {
    assembledElement += ` for several ${element["Present_for_several:"].toLowerCase()}`
    }


if (element["Urgency:"] !== "" || element["Tenesmus:"] !== "" || element["Incontinence_/_soiling:"] !== "")
    {
    assembledElement += ". They report"
    let featureList = []
    const possibleFeatures=["Urgency:", "Tenesmus:", "Incontinence_/_soiling:"]
    possibleFeatures.forEach ((feature)=>
        {
        if (element[feature] !== "")
            {
            featureList.push(feature)
            }
        })
        let featureCount=featureList.length

        featureList.forEach((describedFeature)=>
            {
            if (element[describedFeature] === "No")
                {
                assembledElement +=  " no " 
                }
            else
                {
                assembledElement +=  " a history of "   
                }
            assembledElement += describedFeature.toLowerCase().replaceAll("_", " ").replace(":", "")
            
            switch (featureCount)
                {
                case 1:  assembledElement += ""
                break

                case 2:  assembledElement += " and "
                break

                default:
                    assembledElement += ", "
                }
            featureCount --
            
            })
        }
    
return (assembledElement)
}

export default cobhProcessor